import { implementCustomExpressions } from '../__generated/implementation.js';
export const deckItemExpressions = implementCustomExpressions({
    DeckItem: {
        $projectedEntityRecipes: (s)=>{
            // TODO: This is a bug, raw alias types are not imported to enhanced model
            return [
                ...s.$posts,
                ...s.$fixingSystems,
                ...s.$handrails
            ];
        },
        $parts: (s)=>{
            return s.$projectedEntities.flatMap((entity)=>{
                return entity.$parts;
            });
        },
        $skus: (s)=>{
            return s.$parts.flatMap((part)=>{
                return part.skus;
            });
        },
        $partObjects: (s)=>{
            return s.$parts.flatMap((part)=>{
                return part.objects;
            });
        },
        $deleteFab: (s, state, ctx)=>{
            const shape = ctx.sketchingProjections.getEntityShape(s.id, state, 'main');
            if (shape.type === 'rectangle') {
                return {
                    offsetX: shape.width / 2,
                    offsetZ: shape.depth / 2
                };
            }
            return {
                offsetX: shape.length / 2,
                offsetZ: 0
            };
        }
    }
});

//# sourceMappingURL=deck-item.js.map